import React from 'react';

import './widget-carousel-desktop-basic.scss';

const WidgetCarouselDesktopBasic: React.FC<any> = props => (
    <div className="react-multi-carousel-list w-carousel-d__list">
        <ul className="react-multi-carousel-track ">
            {
                React.Children.map(props.children, child => (
                    <li className={`react-multi-carousel-item w-carousel-d__list__item h-${props.slidesToSlide} ${props.itemClass}`}>
                        {child}
                    </li>
                ))
            }
        </ul>
    </div>
);

export default WidgetCarouselDesktopBasic;
